
















































import { Component, Vue } from 'vue-property-decorator';
import { getTypes, getRounds } from '@/api/assgin';
import { getCurrentDate } from '../../utils/date';

interface IType {
  id: string;
  date: string;
  location_code: string;
  not_completed_count: number;
  type_name: string;
  type_no: string;
}

interface IRound {
  id: string;
  date: string;
  location_code: string;
  round: number;
}

@Component({
  name: 'AssginFilter',
})
export default class extends Vue {
  private types: IType[] = [];

  private rounds: IRound[] = [];

  private typeValue: string[] = [];

  private roundValue = 0;

  private date = '';

  private locationCode = '';

  async created() {
    this.date = getCurrentDate();
    this.locationCode = this.$store.getters['user/locationCode'];
    try {
      this.$overlay(true);
      this.types = await getTypes(this.date, this.locationCode);
      this.rounds = await getRounds(this.date, this.locationCode);
      this.rounds = this.rounds.sort((n1, n2) => n1.round - n2.round);
      if (this.rounds.length > 0) this.roundValue = this.rounds[0].round;
    } finally {
      this.$overlay(false);
    }
  }

  get notCompletedTypes(): IType[] {
    return this.types.filter((type: IType) => type.not_completed_count > 0);
  }

  get allTypesValue(): string[] {
    return this.types.map((type: IType) => type.type_no);
  }

  get isAllSelect(): boolean {
    return this.typeValue.length === this.notCompletedTypes.length;
  }

  private handleRoundClick(round: number) {
    this.roundValue = round;
  }

  private handleSelectAll() {
    this.typeValue = this.notCompletedTypes.map((type: IType) => type.type_no);
  }

  private handleCancelAll() {
    this.typeValue = [];
  }

  private handleLoad() {
    if (this.roundValue === 0 || this.typeValue.length === 0) {
      this.$toast('请选择Type1或Round', {
        color: 'red',
        icon: 'fas fa-info-circle',
      });
      return;
    }
    this.$router.push({
      name: 'Assgin',
      params: {
        types: this.isAllSelect ? this.allTypesValue.join(',') : this.typeValue.join(','),
        round: this.roundValue.toString(),
      },
    });
  }
}
